import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { toastr } from 'react-redux-toastr';
import _ from 'lodash';

import { setSelectedFacebookPage } from '../../../../../store/actions/facebook-messenger';
import { BotsCreators } from '../../../../../store/actions/bots';
import { linkFacebookPageToApp } from './facebook-api';
import { ChannelId } from '../../../../../util/channels';

/**
 * Component for display de facebook messenger actions for channel config
 *
 * @param {object} props
 * @returns
 */
const ChannelFacebookMessengerActions = (props) => {
  const {
    i18n,
    bot,
    facebookAuth,
    setSelectedFacebookPage,
    selectedFacebookPage,
    updateBotRequest,
    channelData,
  } = props;

  const [isChannelActivated, setIsChannelActivated] = useState(false);
  const [currentChannelData, setCurrentChannelData] = useState(channelData);

  /**
   * Called when component is mount, try put some values if user has data on database
   */
  useEffect(() => {
    if (currentChannelData) {
      const { isActive, settings } = currentChannelData;
      setIsChannelActivated(isActive);
      setSelectedFacebookPage(settings);
    }
  }, []);

  /**
   * Called when the user change the channel activated status
   */
  const onActivateChannelChange = () => {
    setIsChannelActivated(!isChannelActivated);
  };

  /**
   * Create or update the bot channel element
   */
  const createOrUpdateBotChannels = (channelActivated = isChannelActivated) => {
    const body = { _id: bot._id, channels: bot.channels };
    const { picture, name } =
      facebookAuth.name !== '' ? facebookAuth : currentChannelData.facebookUser;
    const newChannel = {
      channelId: ChannelId.FacebookMessenger,
      isActive: channelActivated,
      facebookUser: { picture, name },
      settings: { ...selectedFacebookPage },
    };

    if (currentChannelData) {
      body.channels = _.map(body.channels, (channel) =>
        channel.channelId === ChannelId.FacebookMessenger ? newChannel : channel
      );
    } else {
      body.channels = [...body.channels, newChannel];
      setCurrentChannelData({ ...newChannel });
    }

    const payload = {
      channels: body.channels,
    };

    updateBotRequest(body._id, payload);
  };

  /**
   * Called when the save button is click for saving the user options for the Facebook Messenger channel
   */
  const saveFacebookMessengerOptions = () => {
    if (_.isEmpty(selectedFacebookPage)) {
      toastr.error('Erro', 'Selecione uma página do Facebook');
      return;
    }
    if (facebookAuth && facebookAuth.accessToken !== '') {
      linkFacebookPageToApp(selectedFacebookPage).then((response) => {
        if (!response.hasOwnProperty('facebookSuccess')) {
          createOrUpdateBotChannels();
        }
      });
      createOrUpdateBotChannels();
    } else {
      createOrUpdateBotChannels();
    }
  };

  return (
    <div className="col-md-12 p-0">
      <div className="float-left">
        <div className="custom-control custom-switch mt-2 bo-toggle">
          <input
            type="checkbox"
            name="toggle-component"
            id="-toggle-component"
            className="custom-control-input"
            checked={isChannelActivated}
            onChange={onActivateChannelChange}
          />
          <label
            className="custom-control-label bot-control-label"
            htmlFor="-toggle-component"
          />
        </div>
        <div className="enable-channel-text">
          <span>{i18n.t('Ativar canal')}</span>
        </div>
      </div>
      <div className="float-right">
        <button
          type="submit"
          className="btn btn-primary"
          onClick={saveFacebookMessengerOptions}
        >
          {i18n.t('salvar')}
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    bot: state.bots.bot,
    facebookAuth: state.facebookMessenger.facebookAuth,
    selectedFacebookPage: state.facebookMessenger.selectedFacebookPage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { ...BotsCreators, setSelectedFacebookPage },
    dispatch
  );
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ChannelFacebookMessengerActions))
);
